<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">订单已被取消</h2>
            <p class="weui-msg__desc">{{cancelReason()}}</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="goback()">返回</div><br>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-cancel',
  methods: {
    goback(){
      this.goto('/order');
    },
    cancelReason(){
      if(this.$route.query.reason=="timeout"){
        return "因为订单超过1小时未支付，已被取消，如仍需该服务，请重新下单";
      }
      else{
        return "订单已被客服取消，如有其他疑问，请立即联系我们";
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}

.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/order-cancel.vue